import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { investmentStatus } from '../../../login/utils/Status';
import CancelInvestmentModal from '../modal/CancelInvestment';

const DealInfoOnDealPayment: React.FC = () => {
    const dealPayment = useSelector((state: RootState) => state.dealPayment.payment);
    return (
        <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto mt-6">
            <div className="py-4 px-4">
                <div className="flex justify-between">
                    <div className="w-9/12">
                        <p className="text-base">
                            Deal:{' '}
                            <span className="text-gray-900 SourceSansPro-SemiBold">
                                {dealPayment && dealPayment.deal.title}
                            </span>
                        </p>
                        <p className="text-base flex md:hidden">
                            Amount:{' '}
                            <span style={{ color: '#c49a6d' }} className="SourceSansPro-SemiBold mr-4 ml-1">
                                {dealPayment?.investment.amount &&
                                    `${
                                        dealPayment?.investment.amount.currency
                                    } ${dealPayment?.investment.amount.amountUpto2dp?.toLocaleString()}`}
                            </span>
                        </p>
                    </div>
                    <div className="w-1/4">
                        <div className="flex items-center justify-end">
                            <p className="text-base hidden md:flex">
                                Amount:{' '}
                                <span style={{ color: '#c49a6d' }} className="SourceSansPro-SemiBold mr-4 ml-1">
                                    {dealPayment?.investment.amount &&
                                        `${
                                            dealPayment?.investment.amount.currency
                                        } ${dealPayment?.investment.amount.amountUpto2dp?.toLocaleString()}`}
                                </span>
                            </p>
                            {dealPayment?.investment.status === investmentStatus.PendingPaymentReceipt && (
                                <CancelInvestmentModal investmentUUID={dealPayment.investment.uuid} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="pt-4 mb-4 w-full border-b-2 border-fuchsia-600" />
                <div>
                    {dealPayment?.deal.bankAccount && (
                        <p className="text-base">
                            Please transfer amount into the following bank account with the indicated reference. Upon
                            successful transfer, please upload the Proof of Payment
                        </p>
                    )}
                    {!dealPayment?.deal.bankAccount && (
                        <p className="text-base">
                            Thank you for your interest! Our team will contact you shortly regarding the settlement
                            process
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DealInfoOnDealPayment;
